<nibtravel-header [logoConfig]="logoConfig"></nibtravel-header>
<ng-content select="[content]"></ng-content>
<nibtravel-footer [logoConfig]="logoConfig" [footerConfig]="footerConfig">
  <ng-content
    select="[footer-quick-links]"
    ngProjectAs="quick-links"
  ></ng-content>
  <ng-content
    select="[footer-content]"
    ngProjectAs="footer-content"
  ></ng-content>
</nibtravel-footer>
